/* qeslint-disable */
/* eslint-disable camelcase */
// q@ts-nocheck

import { Theme } from "../theme";
import { LayoutParameters } from "../Settings";
import { Dispatcher } from "../utils/util_dispatcher";
import { proxyCtx } from "../utils/utils";

const DIAMOND_SIZE = LayoutParameters.DIAMOND_SIZE;
const LINE_HEIGHT = LayoutParameters.LINE_HEIGHT;

interface Pointer {
    dx: number;
    dy: number;
    moved: boolean;
    offsetx: number;
    offsety: number;
    startx: number;
    starty: number;
    x: number;
    y: number;
}

interface Frame {
    time: number;
    [key: string]: any;
}

interface DiamondOptions {
    indexOfFrame: number;
    frame: Frame;
    x: number;
    y: number;
    trackCanvas: HTMLCanvasElement;
    ctx_wrap: ReturnType<typeof proxyCtx>;
    dispatcher: Dispatcher;
    xToTime: (x: number) => number;
}

export default class Diamond {
    private indexOfFrame: number;
    private frame: Frame;
    private x: number;
    private y: number;
    private trackCanvas: HTMLCanvasElement;
    private ctx_wrap: ReturnType<typeof proxyCtx>;
    private dispatcher: Dispatcher;
    private xToTime: (x: number) => number;
    private isOver: boolean = false;
    private y2: number;

    constructor(options: DiamondOptions) {
        this.indexOfFrame = options.indexOfFrame;
        this.frame = options.frame;
        this.x = options.x;
        this.y = options.y;
        this.trackCanvas = options.trackCanvas;
        this.ctx_wrap = options.ctx_wrap;
        this.dispatcher = options.dispatcher;
        this.xToTime = options.xToTime;

        this.y2 = this.y + LINE_HEIGHT * 0.5 - DIAMOND_SIZE / 2;
    }

    path(ctxWrap: ReturnType<typeof proxyCtx>): void {
        ctxWrap
            .beginPath()
            .moveTo(this.x, this.y2)
            .lineTo(this.x + DIAMOND_SIZE / 2, this.y2 + DIAMOND_SIZE / 2)
            .lineTo(this.x, this.y2 + DIAMOND_SIZE)
            .lineTo(this.x - DIAMOND_SIZE / 2, this.y2 + DIAMOND_SIZE / 2)
            .closePath();
    }

    paint(ctxWrap: ReturnType<typeof proxyCtx>): void {
        this.path(ctxWrap);

        if (!this.isOver) {
            ctxWrap.fillStyle(Theme.c);
        } else {
            ctxWrap.fillStyle("yellow");
        } // Theme.d

        ctxWrap.fill().stroke();
    }

    mouseover(): void {
        this.isOver = true;
        this.trackCanvas.style.cursor = "move"; // pointer move ew-resize
        this.paint(this.ctx_wrap);
    }

    mouseout(): void {
        this.isOver = false;
        this.trackCanvas.style.cursor = "default";
        this.paint(this.ctx_wrap);
    }

    /**
     * @param e
     */
    mouseDrag(e: Pointer): void {
        let updatedTime = this.xToTime(this.x + e.dx);

        updatedTime = Math.max(0, updatedTime);

        // TODO limit moving to neighbours
        this.frame.time = updatedTime;

        this.dispatcher.fire("frameChanged", {
            indexOfFrame: this.indexOfFrame,
            updatedTime: updatedTime
        });
    }
}
